export const sriLankaGroupPackage = {
  id: "sri-lanka-7d6n",
  title: "Sri Lanka Group Tour",
  country: "Sri Lanka",
  days: 7,
  nights: 6,
  price: {
    adult: "₹93,200 per adult + 5% GST + 5% TCS",
    childWithBed: "₹81,500 per child (with bed) + 5% GST + 5% TCS",
    childNoBed: "₹75,500 per child (no bed) + 5% GST + 5% TCS",
  },

  thumbnail:
    "https://images.pexels.com/photos/33592689/pexels-photo-33592689.jpeg",

  description:
    "Experience the cultural heritage, scenic landscapes, and serene beaches of Sri Lanka in this 7-day guided group tour. From ancient temples and spice gardens to tea plantations and coastal beauty, this journey covers the best of Sri Lanka.",

  highlights: [
    "Visit Pinnawala Elephant Orphanage",
    "Explore Dambulla Cave Temple",
    "City tour of Kandy with cultural dance show & Temple of Tooth",
    "Tea Plantation visit & Ramboda Falls",
    "Nuwara Eliya sightseeing including Gregory Lake & Hakgala Gardens",
    "Bentota beaches, Turtle Hatchery & Madu River boat safari",
    "Colombo city tour & shopping",
  ],

  included: [
    "Return economy class airfare from Mumbai",
    "Visa charges as per itinerary",
    "Accommodation on twin sharing basis",
    "Meals as mentioned (Breakfast, Lunch & Dinner as per itinerary)",
    "Travel insurance up to 60 years of age",
    "All transfers & sightseeing in a coach",
    "All entrance fees for listed sightseeing",
    "Services of Tour Manager throughout the tour",
  ],

  excluded: [
    "5% GST & 5% TCS",
    "Increase in fuel surcharge or taxes",
    "Extension/deviation of tour route",
    "Porterage, laundry, shopping, telephone, personal expenses",
    "Alcoholic beverages & mineral water (unless specified)",
    "Extra expenses due to natural calamities or political disturbances",
    "Medical expenses due to illness/accident",
    "Private transfers (if taken instead of coach)",
    "Upgradation in airline class or hotel room category",
    "Anything not specifically mentioned in inclusions",
  ],

  itinerary: [
    {
      day: 1,
      title: "Airport – Pinnawala – Dambulla",
      description:
        "Arrive in Sri Lanka. Meet representative and proceed via Pinnawala to Dambulla. Visit Pinnawala Elephant Orphanage and Dambulla Cave Temple. Overnight in Dambulla.",
      photo: "https://images.pexels.com/photos/18199789/pexels-photo-18199789.jpeg",
    },
    {
      day: 2,
      title: "Dambulla – Matale – Kandy",
      description:
        "After breakfast, depart for Kandy via Matale. Visit a spice garden & Batik factory. Evening city tour of Kandy covering city, lake, bazaars, gem museum, Temple of Sacred Tooth Relic & cultural dance show. Overnight in Kandy.",
      photo: "https://images.pexels.com/photos/33404364/pexels-photo-33404364.jpeg",
    },
    {
      day: 3,
      title: "Kandy – Nuwara Eliya",
      description:
        "After breakfast, drive to Nuwara Eliya. En-route visit a Tea Plantation & factory and Ramboda Falls. Check in & relax. Overnight stay in Nuwara Eliya.",
      photo: "https://images.pexels.com/photos/13765678/pexels-photo-13765678.jpeg",
    },
    {
      day: 4,
      title: "Nuwara Eliya Sightseeing",
      description:
        "City tour of Nuwara Eliya. Visit Gregory Lake Park, Sita Amman Temple, and Ashok Vatika (Hakgala Botanical Garden). Overnight stay in Nuwara Eliya.",
      photo: "https://images.pexels.com/photos/32414014/pexels-photo-32414014.jpeg",
    },
    {
      day: 5,
      title: "Nuwara Eliya – Bentota",
      description:
        "After breakfast, proceed to Bentota. Enjoy the scenic drive and check-in at hotel. Relax and overnight stay in Bentota.",
      photo: "https://images.pexels.com/photos/15589614/pexels-photo-15589614.jpeg",
    },
    {
      day: 6,
      title: "Bentota – Galle – Bentota",
      description:
        "Breakfast at hotel and proceed to Galle for sightseeing. Visit Galle Fort & Dutch architecture. Return to Bentota and visit Turtle Hatchery. Enjoy Madu River boat safari. Overnight in Bentota. (Meals: Breakfast, Lunch & Dinner)",
      photo: "https://images.pexels.com/photos/27669315/pexels-photo-27669315.jpeg",
    },
    {
      day: 7,
      title: "Bentota – Colombo – Airport",
      description:
        "After breakfast, check out and proceed for Colombo city tour. Evening transfer to airport for flight to Mumbai. Tour ends with happy memories.",
      photo: "https://images.pexels.com/photos/1450349/pexels-photo-1450349.jpeg",
    },
  ],

  gallery: [
    // existing 5
    "https://images.pexels.com/photos/2403209/pexels-photo-2403209.jpeg",
    "https://images.pexels.com/photos/3073033/pexels-photo-3073033.jpeg",
    "https://images.pexels.com/photos/1005417/pexels-photo-1005417.jpeg",
    "https://images.pexels.com/photos/34128250/pexels-photo-34128250.jpeg",
    "https://images.pexels.com/photos/12343661/pexels-photo-12343661.jpeg",
    // itinerary photos
    "https://images.pexels.com/photos/18199789/pexels-photo-18199789.jpeg",
    "https://images.pexels.com/photos/33404364/pexels-photo-33404364.jpeg",
    "https://images.pexels.com/photos/13765678/pexels-photo-13765678.jpeg",
    "https://images.pexels.com/photos/32414014/pexels-photo-32414014.jpeg",
    "https://images.pexels.com/photos/15589614/pexels-photo-15589614.jpeg",
    "https://images.pexels.com/photos/27669315/pexels-photo-27669315.jpeg",
    "https://images.pexels.com/photos/1450349/pexels-photo-1450349.jpeg",
  ],

  groupDates: [
    { group: "Group 1", start: "2025-10-25", end: "2025-10-31" },
    { group: "Group 2", start: "2025-11-20", end: "2025-11-26" },
    { group: "Group 3", start: "2025-12-15", end: "2025-12-21" },
    { group: "Group 4", start: "2026-01-23", end: "2026-01-29" },
  ],

  brochure:
    "https://firebasestorage.googleapis.com/v0/b/paryatakadmin.firebasestorage.app/o/packages%2Fsri_lanka_group_brochure.pdf?alt=media&token=example",

  rating: {
    stars: 4.9,
    reviews: 140,
  },

  reviews: [
    {
      stars: 5,
      review: "The trip was amazing! Everything was well organized and the guide was excellent.",
      name: "Neha Patil",
    },
    {
      stars: 5,
      review: "Sri Lanka is beautiful! Tea plantations and Bentota beaches were my favorite.",
      name: "Rajesh Iyer",
    },
    {
      stars: 4,
      review: "Good hotels and smooth travel arrangements. Food variety could improve a bit.",
      name: "Pooja Shah",
    },
  ],
};
